// Uploadt één bestand naar een signed url (v4, PUT) en meldt de voortgang.
//
// Nodig omdat de bestaande uploads in de app via de Storage-SDK naar een pad
// gaan dat de opslagregels moeten openzetten; een signed url is een gewone
// HTTP-PUT met de headers uit de handtekening. `fetch` meldt geen voortgang
// bij het verzenden, XMLHttpRequest wel.
// AI-CONTEXT: See docs/features/storytelling-deellink.md

/**
 * @param {string} url - De signed url van de server
 * @param {Blob} file
 * @param {Object<string, string>} headers - Precies de headers die de server teruggaf, anders klopt de handtekening niet
 * @param {(percent: number) => void} onProgress - Hele procenten
 * @param {typeof XMLHttpRequest} [XHR] - Alleen voor tests
 * @returns {Promise<void>}
 */
const putFileWithProgress = (url, file, headers, onProgress, XHR = XMLHttpRequest) => new Promise((resolve, reject) => {
    const xhr = new XHR()
    xhr.open('PUT', url)
    Object.entries(headers).forEach(([key, value]) => xhr.setRequestHeader(key, value))
    xhr.upload.onprogress = (e) => {
        if (e.lengthComputable && e.total > 0) onProgress(Math.round((e.loaded / e.total) * 100))
    }
    // De opslag weigert met een status (bijv. 400 bij een te groot bestand), niet met een netwerkfout.
    xhr.onload = () => (xhr.status >= 200 && xhr.status < 300
        ? resolve()
        : reject(new Error(`Upload mislukt (${xhr.status})`)))
    xhr.onerror = () => reject(new Error('Upload mislukt (netwerk)'))
    xhr.send(file)
})

export default putFileWithProgress
